export const navObjOne = {
    img1: require('../../images/logo_1.png'),
    alt1: "ATTOCHRON",
    productPDF: require('../../docs/Attochron_ALTIS-7_Specifications 041524.pdf'),
}